import { jsx as _jsx } from "react/jsx-runtime";
import { HtmlInclude, ScriptTypes } from '../../common/html-include/HtmlInclude';
import { AemComponentType } from '@as-react/common-types';
const generateFAQStructuredData = (props) => {
    const data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [],
    };
    props[':itemsOrder'].map((collapsibleListItem, index) => {
        const listItem = props[':items'][collapsibleListItem];
        if (!Object.values(AemComponentType).includes(listItem[':type'])) {
            return null;
        }
        data.mainEntity[index] = {
            '@type': 'Question',
            name: listItem.title,
        };
        return listItem[':itemsOrder'].map((collapsibleListItemComponent) => {
            const component = listItem[':items'][collapsibleListItemComponent];
            if (component[':type'] !== AemComponentType.TEXT_BLOCK_V2)
                return;
            if (!data.mainEntity[index].acceptedAnswer) {
                data.mainEntity[index].acceptedAnswer = {
                    '@type': 'Answer',
                    text: component.text,
                };
            }
            else {
                data.mainEntity[index].acceptedAnswer.text += component.text;
            }
        });
    });
    return data;
};
export const CollapsibleListLD = props => (_jsx(HtmlInclude, { scriptFragment: JSON.stringify(generateFAQStructuredData(props), null, 2), scriptType: ScriptTypes.LD_JSON }));
